/** Runtime configuration, read from /config.js so one image serves every environment. */
declare global {
  interface Window {
    __TIMEFLY__?: { apiBase?: string; sentryDsn?: string };
  }
}
export const API_BASE: string = window.__TIMEFLY__?.apiBase ?? 'http://localhost:8080/api/v1';

/** Browser errors to Sentry (project timefly-web), off when the container sets none. */
export const SENTRY_DSN: string = window.__TIMEFLY__?.sentryDsn ?? '';
